import {
  postJsonAsync,
  navigateTo
} from 'shared/actions';
import {toastr} from 'react-redux-toastr';
import {
  setIncludePastTournamentsInState,
  setSearchResultInState
} from './actionTypes';

export const handleIncludePastTournamentsChange = checked => dispatch => {
  dispatch(setIncludePastTournamentsInState(checked));
  dispatch(handleSearch());
};

export const handleSearchEnterKeyPress = event => dispatch => {
  if(event.keyCode === 13) {
    event.preventDefault();
    event.stopPropagation();
    dispatch(handleSearch());
  }
};

export const handleSearch = () => (dispatch, getState) => {
  const adminHomeState = getState().admin.home,
    searchByOption = adminHomeState.searchByOptions.find(x => x.selected).id,
    searchValue = adminHomeState.searchValue.trim(),
    includePastTournaments = adminHomeState.includePastTournaments;

  if (!searchByOption) return;

  if (!searchValue || searchValue.trim().length < 3) return;
  
  let url = '';
  let body = {
    SearchTerms: searchValue,
    includePastTournaments
  };

  if (searchByOption === 1){
    url = 'admin/entry/searchByBowler';
  }
  else if (searchByOption === 2){
    url = 'admin/entry/searchByCaptOrCoordinator';
  }
  else if (searchByOption === 3){
    url = 'admin/entry/searchByEntry';
  }

  dispatch(postJsonAsync(url, body))
  .then(result => {
    dispatch(setSearchResultInState(result.items));
    if (result.showingLinkedEntryInstead){
      toastr.warning(`Showing the linked entry`, 
        `The entry ${searchValue} is linked to the entry ${result.items[0].entryNumber}. You can only modify entry ${result.items[0].entryNumber}`);
    }
  });
};
  
export const handleEntryClick = entryId => dispatch => {
  dispatch(navigateTo(`admin/entry/${entryId}`));
};

export const handleCaptainClick = captainId => dispatch => {
  dispatch(navigateTo(`admin/captain/${captainId}`));
};



// WEBPACK FOOTER //
// ./src/features/admin/home/actions.js